import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "../../../axios";
import formatCurrency from "../../../utils/formatCurrency";
import { STORAGE_URL } from "../../../constants";


export default function OrderDetailPage() {
    const { id } = useParams();
    const [order, setOrder] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        axios.get(`/orders/${id}`).then((res) => setOrder(res.data));
    }, [id]);

    const handleVerify = async () => {
        setLoading(true);
        try {
            await axios.post(`/admin/orders/${id}/verify`);
            setOrder({ ...order, status: "verified" });
        } catch {
            alert("Gagal memverifikasi pesanan.");
        } finally {
            setLoading(false);
        }
    };

    function StatusBadge({ status }) {
        let color = "secondary";
        let label = status;
        switch (status) {
            case "pending":
                color = "warning";
                label = "Pending";
                break;
            case "paid":
                color = "info";
                label = "Paid";
                break;
            case "verified":
                color = "success";
                label = "Verified";
                break;
            case "canceled":
                color = "danger";
                label = "Canceled";
                break;
            default:
                color = "secondary";
        }
        return (
            <span className={`badge bg-${color} text-capitalize`}>
                {label}
            </span>
        );
    }

    if (!order) return <p>Memuat detail pesanan...</p>;

    const total = parseInt(order.price_total || 0) + parseInt(order.unique_code || 0);

    return (
        <div className="container py-5">
            <div className="card shadow">
                <div className="card-header bg-secondary text-white">
                    <h4 className="mb-0">Invoice Pesanan</h4>
                </div>

                <div className="card-body">
                    <div className="row mb-4">
                        {/* <div className="col-md-6">
                            <h5 className="mb-2">Dari:</h5>
                            <p className="mb-1"><strong>Nama Toko Album Foto</strong></p>
                            <p>Email: admin@albumfoto.com</p>
                        </div> */}
                        <div className="col-md-6 text-md-start">
                            <h5 className="mb-2">Customer:</h5>
                            <p className="mb-1"><strong>{order.user?.name}</strong></p>
                            <p>No HP: {order.user?.phone}</p>
                        </div>
                    </div>

                    <hr />

                    <div className="row mb-4">
                        <div className="col-md-12">
                            <p><strong>ID Pesanan:</strong> {String(order.id).substring(0, 8).toUpperCase()}</p>
                            <p><strong>Status:</strong> <StatusBadge status={order.status} /></p>
                            <p><strong>Tanggal:</strong> {new Date(order.created_at).toLocaleString()}</p>
                        </div>
                    </div>

                    <table className="table table-bordered">
                        <thead className="table-light">
                            <tr>
                                <th>Produk</th>
                                <th>Ukuran</th>
                                <th>Cover Design</th>
                                <th>Cover Fabric</th>
                                <th>Halaman</th>
                                <th>Subtotal</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{order.product?.name}</td>
                                <td>{order.size?.width} cm x {order.size?.height} cm</td>
                                <td>{order.cover_design?.name}</td>
                                <td>{order.cover_fabric?.name}</td>
                                <td>{order.pages} halaman</td>
                                <td className="text-end">Rp {formatCurrency(order.price_total)}</td>
                            </tr>
                            <tr>
                                <td colSpan="5" className="text-end"><strong>Kode Unik</strong></td>
                                <td className="text-end">Rp {formatCurrency(order.unique_code)}</td>
                            </tr>
                            <tr>
                                <td colSpan="5" className="text-end"><strong>Total</strong></td>
                                <td className="text-end"><strong>Rp {total.toLocaleString("id-ID")}</strong></td>
                            </tr>
                        </tbody>
                    </table>

                    {order.proof_file ? (
                        <div className="mt-4">
                            <h5>Bukti Transfer:</h5>
                            <img
                                src={`${STORAGE_URL}${order?.proof_file}`}
                                alt="Bukti Transfer"
                                style={{ maxWidth: 400, border: "1px solid #ccc" }}
                            />
                        </div>
                    ) : (
                        <div className="alert alert-warning mt-4">Belum ada bukti transfer diunggah.</div>
                    )}

                    {order.status === "paid" && (
                        <button onClick={handleVerify} className="btn btn-success mt-3" disabled={loading}>
                            {loading ? "Memverifikasi..." : "Verifikasi Pesanan"}
                        </button>
                    )}

                    <div className="mt-4">
                        <Link to="/orders" className="btn btn-secondary">← Kembali ke Daftar Pesanan</Link>
                    </div>
                </div>
            </div>
        </div>
    );
}